/* ─────────────────────────────────────────────────────────
   bronzata-quiz-pdp-hook.js
   On PDP load: reads ?quiz=1&shade1=X&shade2=Y&offer=A|B&useCase=...
   Auto-selects the matching Kaching Bundles offer + shade variants.

   BUNDLE OFFER 2 LOGIC (preselect both cream slots)
   ──────────────────────────────────────────────────
   Bundle (Offer B) has 2 cream slots preselected by Kaching.
   The quiz delivers shade1 and shade2 to fill those slots:

   • single use case (q5 = naturale OR abbronzata)
       → quiz sends shade1 = shade2 = same recommended shade
       → both slots end up with SAME tonalità (still benefits from
         the bundle: brush included + extra discount)

   • dual use case (q5 = entrambe)
       → quiz sends shade1 = pelle naturale shade,
         shade2 = abbronzata shade (typically different)
       → each slot gets its own tonalità

   Default behaviour: when quiz=1 we ALWAYS preselect Offer B
   (the bundle) — Bronzata's primary upsell — unless the user
   explicitly opted into single via ?offer=A.

   Kaching renders its app block asynchronously — this script
   uses a MutationObserver to wait for the bundle UI then clicks
   the right offer + sets the shade dropdowns.

   TODO when Kaching DOM is finalized on DEV theme:
   - Confirm offer toggle selector (currently best-guess)
   - Confirm shade select element pattern
   - Confirm slot 1 / slot 2 ordering
   ───────────────────────────────────────────────────────── */
(function () {
  'use strict';

  const params = new URLSearchParams(window.location.search);
  if (params.get('quiz') !== '1') return;

  const shade1 = params.get('shade1');
  // shade2 falls back to shade1 (single use case → same shade in both slots)
  const shade2 = params.get('shade2') || shade1;
  // Default to Offer B (bundle) — Bronzata's primary upsell
  const offer = params.get('offer') || 'B';
  const useCase = params.get('useCase') || '';  // naturale|abbronzata|entrambe

  const TIMEOUT_MS = 8000;
  const POLL_MS = 200;
  const startTs = Date.now();

  console.log('[bzq-pdp] quiz redirect', { shade1, shade2, offer, useCase });

  // Try to find Kaching offer toggle buttons. Common patterns:
  //   [data-kaching-deal-id] · .kaching-bundles-offer · .kb-offer-tile · input[name="deal"]
  const OFFER_SELECTORS = [
    '[data-kaching-deal-id]',
    '[data-deal-id]',
    '.kaching-bundles-offer',
    '.kb-bundle-option',
    '.kaching-bundles-deal',
    'input[type=radio][name*="deal"]',
  ];

  // Shade dropdown / variant select patterns
  const SHADE_SELECTORS = [
    '[data-kaching-variant-select]',
    '[data-kaching-product-variant]',
    '.kaching-bundles-product-variant select',
    'select[name*="variant"]',
    'select[name*="option"]',
  ];

  function findOfferButton(offerId) {
    // Try multiple strategies
    for (const sel of OFFER_SELECTORS) {
      const nodes = document.querySelectorAll(sel);
      for (const n of nodes) {
        const txt = (n.textContent || '').toLowerCase();
        const dealId = n.dataset.dealId || n.dataset.kachingDealId || '';
        // Heuristic: Offer A = 1 prodotto / Offer B = 2 prodotti
        if (offerId === 'B' && (txt.includes('2') || txt.includes('bundle') || txt.includes('kit') || dealId.includes('2'))) {
          return n;
        }
        if (offerId === 'A' && (txt.includes('1') || dealId.includes('1') || txt.includes('singol'))) {
          return n;
        }
      }
    }
    return null;
  }

  function findShadeSelects() {
    for (const sel of SHADE_SELECTORS) {
      const nodes = document.querySelectorAll(sel);
      if (nodes.length > 0) return Array.from(nodes);
    }
    return [];
  }

  function selectShadeOnElement(el, shade) {
    if (!el || !shade) return false;
    if (el.tagName === 'SELECT') {
      const options = Array.from(el.options);
      const match = options.find(o => {
        const v = (o.value || '').toLowerCase();
        const t = (o.textContent || '').toLowerCase();
        const s = shade.toLowerCase();
        return v.indexOf(s) !== -1 || t.indexOf(s) !== -1;
      });
      if (match) {
        el.value = match.value;
        el.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    } else {
      // Buttons / custom select
      const opts = el.querySelectorAll('[data-value], [data-shade], button, li');
      for (const o of opts) {
        const v = (o.dataset.value || o.dataset.shade || o.textContent || '').toLowerCase();
        if (v.indexOf(shade.toLowerCase()) !== -1) {
          o.click();
          return true;
        }
      }
    }
    return false;
  }

  let done = false;

  function tryApply() {
    if (done) return true;
    if (Date.now() - startTs > TIMEOUT_MS) {
      console.warn('[bzq-pdp] timeout waiting for Kaching');
      return true;  // stop polling
    }

    // Step 1 — click the right offer
    if (offer) {
      const btn = findOfferButton(offer);
      if (btn) {
        try {
          if (btn.tagName === 'INPUT' && btn.type === 'radio') {
            btn.checked = true;
            btn.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            btn.click();
          }
          console.log('[bzq-pdp] offer selected', offer);
        } catch (e) { console.warn('[bzq-pdp] offer click failed', e); }
      } else {
        return false;
      }
    }

    // Step 2 — set shade(s) — give Kaching time to render variant selectors after offer click
    setTimeout(() => {
      const selects = findShadeSelects();
      if (selects.length === 0) {
        console.warn('[bzq-pdp] no shade selects found');
        return;
      }
      // Bundle Offer B has 2 cream slots — fill both, with shade2 falling
      // back to shade1 for single use case (same tonalità in both slots).
      if (selects[0]) selectShadeOnElement(selects[0], shade1);
      if (selects[1]) selectShadeOnElement(selects[1], shade2 || shade1);
      console.log('[bzq-pdp] shades applied', { slot1: shade1, slot2: shade2 || shade1 });
      done = true;
    }, 500);

    return true;
  }

  function startObserver() {
    const observer = new MutationObserver(() => {
      if (tryApply()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), TIMEOUT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (!tryApply()) startObserver();
    });
  } else {
    if (!tryApply()) startObserver();
  }
})();
